import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import { CampaignFolderSchema } from '../../../../../../schemas/CampaignFolderSchema'
import axiosService from '../../../../../../utils/AxiosService'
import Input from '../../../../../FormComponents/Input'
import { toastError, toastSuccess } from '../../../../../FormComponents/Toasts'
import Modal from '../../../../../Modal/Modal'

export default observer(function CreateFolderButton() {
  const { id } = useParams()
  const [open, setOpen] = useState(false)
  const { campaignFolders } = useContext(CampaignContext)

  const createFolder = campaign_folder => {
    axiosService.post(`/api/project_manager/campaigns/${id}/campaign_folders`, { campaign_folder })
    .then(folder => {
      campaignFolders.push(folder)
      setOpen(false)
      toastSuccess('Folder created')
    })
    .catch(({ data: { error } }) => toastError(error))
  }

  return (
    <div>
      <button className="border-2 border-dashed border-rb-green text-center bg-rb-green/25 h-18 rounded w-80 font-bold" onClick={() => setOpen(true)}>Create Folder</button>

      <Modal isOpen={open} onClose={() => setOpen(false)}>
        <Modal.Header>Create New Folder</Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={CampaignFolderSchema}
            initialValues={{ name: '' }}
            onSubmit={createFolder}
          >
            {({ handleBlur, handleChange, values, errors, touched }) => (
              <Form>
                <div className="form-item-container w-full">
                  <Input autoFocus error={touched.name && errors.name} placeholder="Name" name='name' onChange={handleChange} onBlur={handleBlur} value={values.name} />
                  <button
                    type="submit"
                    className="bg-rb-green text-white px-4 py-2 rounded-2xl w-full mt-4 dark:text-rb-dark-mode"
                  >
                    Create Folder
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  )
})